import { render, staticRenderFns } from "./Scommessa.vue?vue&type=template&id=b5587fac&"
import script from "./Scommessa.vue?vue&type=script&lang=js&"
export * from "./Scommessa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports